<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
         <v-btn
          v-bind:disabled="enabled"
          v-bind="attrs"
          v-on="on"
          class="mb-1"
          icon
        >
        <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Редактирование транспортного средства</span>
        </v-card-title>
        <v-subheader>С помощью данной формы вы можете добавить или изменить номера карт</v-subheader>
        <v-card-text>
            <v-form
                ref="form"
                v-model="valid"
            >
            <v-row>
                <v-col cols="12" sm="12">
                    <v-text-field
                    v-model="item.schemaName"
                    label="Схема"
                    required
                    readonly
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-text-field
                    v-model="item.deviceName"
                    label="Наименование"
                    required
                    readonly
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <v-text-field
                    v-model="item.vehicleRegNumber"
                    label="Гос.номер"
                    required
                    readonly
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-combobox
                    v-model="item.petrolCard"
                    :items="petrolCards"
                    item-text="cardNumber"
                    item-value="id"
                    label="ППР"
                    ></v-combobox>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-combobox
                    v-model="item.optiCard"
                    :items="opti24Cards"
                    item-text="cardNumber"
                    item-value="id"
                    label="Опти24"
                    ></v-combobox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-combobox
                    v-model="item.shellCard"
                    :items="shellCards"
                    item-text="cardNumber"
                    item-value="id"
                    label="Shell"
                    ></v-combobox>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-combobox
                    v-model="item.rnCard"
                    :items="rosneftCards"
                    item-text="cardNumber"
                    item-value="id"
                    label="Роснефть"
                    ></v-combobox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-combobox
                    v-model="item.nesteCard"
                    :items="nesteCards"
                    item-text="cardNumber"
                    item-value="id"
                    label="NESTE OIL"
                    ></v-combobox>
                </v-col>
            </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="primary" :disabled="!valid" text @click="validate">Продолжить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    enabled: Boolean,
    item: Object
  },
  computed: {
    ...mapState('device', {
      cards: state => state.cards
    })
  },
  data: () => ({
    valid: true,
    dialog: false,
    petrolCards: null,
    opti24Cards: [],
    shellCards: [],
    rosneftCards: [],
    nesteCards: []
  }),
  watch: {
    cards: function () {
      this.petrolCards = this.cards[0].cards
      this.opti24Cards = this.cards[1].cards
      this.shellCards = this.cards[2].cards
      this.rosneftCards = this.cards[3].cards
      this.nesteCards = this.cards[4].cards
    },
    item: function () {
      this.deviceName = this.item.deviceName
    }
  },
  mounted () {
    this.getCards()
  },
  methods: {
    validate () {
      this.$refs.form.validate()
      this.dialog = false
      this.$emit('onValidate', this.item)
    },
    ...mapActions({
      getCards: 'device/getCards'
    })
  }
}
</script>
